import React from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import BaseCliScript2 from '../../AbstractObjects/GatewayPlan/InnerPages/BaseCliScript2';

const pageSchema = GatewayGetSchema.pages.cliScript2;
const pageId = pageSchema.pageId;

function PlanCliScript2({
    planObject,
    setPlanData
}) {

    let pageData = planObject[pageId];
    
    return (
        <BaseCliScript2
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanCliScript2;